import { ApolloError } from '@apollo/client';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  IPaginationProps,
  LinearProgress,
  LoadedContent,
} from '@occc-app/design-system';
import { GamesListItemFragment } from '@occc/graphql';

import { GameTableRow } from './GameTableRow';

type GameTableProps = {
  offers: GamesListItemFragment[] | null | undefined;
  loading: boolean;
  error?: ApolloError;
  onRowClick: (id: string) => void;
  paginationProps: IPaginationProps;
  areActionsVisible: boolean;
};

export const GameTable = ({
  offers,
  loading,
  error,
  onRowClick,
  paginationProps,
  areActionsVisible,
}: GameTableProps) => {
  const renderData = (items: GamesListItemFragment[]) => {
    return (
      <>
        {loading && <LinearProgress />}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Marketing Content</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align='center'>Fulfillments</TableCell>
              {areActionsVisible && <TableCell align='right'>Actions</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <GameTableRow
                key={item.id}
                offer={item}
                areActionsVisible={areActionsVisible}
                onItemClick={onRowClick}
              />
            ))}
          </TableBody>
        </Table>
        <Pagination {...paginationProps} />
      </>
    );
  };

  return (
    <LoadedContent<GamesListItemFragment>
      error={error}
      loading={loading}
      items={offers}
      renderData={renderData}
    />
  );
};
